import axios from "axios";

class wearPiecesServices {
  constructor() {
    this.service = axios.create({
      baseURL: process.env.REACT_APP_SERVICE_WEARPIECES_URL
    });
  }

  getFrameNumber = plate => {
    return this.service
      .get(`/GetCaracteristicasVehiculos.aspx?cmat=${plate}`)
      .then(response => response)
      .catch(e => console.log(e));
  };

  getWearPiecesByFrameNumber = frameNumber => {
    let discosDelanterosPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Discos+delanteros&pmo=50.82&pos=1&bdat=true&mantAct=1&ccha=${
        frameNumber.data
      }`
    );
    let discosTraserosPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Discos+traseros&pmo=50.82&pos=3&bdat=true&mantAct=3&ccha=${
        frameNumber.data
      }`
    );
    let pastillasDelanterasPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Pastillas+delanteras&pmo=50.82&pos=0&bdat=true&mantAct=0&ccha=${
        frameNumber.data
      }`
    );
    let pastillasTraserasPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Pastillas+traseras&pmo=50.82&pos=2&bdat=true&mantAct=2&ccha=${
        frameNumber.data
      }`
    );
    let amortiguadoresDelanterosPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Amortiguadores+delanteros&pmo=50.82&pos=6&bdat=true&mantAct=6&ccha=${
        frameNumber.data
      }`
    );
    let amortiguadoresTraserosPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Amortiguadores+traseros&pmo=50.82&pos=7&bdat=true&mantAct=7&ccha=${
        frameNumber.data
      }`
    );
    let bateriaPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Baterias&pmo=50.82&pos=4&bdat=true&mantAct=4&ccha=${
        frameNumber.data
      }`
    );
    let escobillasPromise = this.service.get(
      `/GetMantenimientoExtensivo.aspx?mansel=Escobillas&pmo=50.82&pos=5&bdat=true&mantAct=5&ccha=${
        frameNumber.data
      }`
    );

    return Promise.all([
      discosDelanterosPromise,
      discosTraserosPromise,
      pastillasDelanterasPromise,
      pastillasTraserasPromise,
      amortiguadoresDelanterosPromise,
      amortiguadoresTraserosPromise,
      bateriaPromise,
      escobillasPromise
    ]).then(response => response)
    .catch(e => console.log(e));
  };
}

export default wearPiecesServices;
